import React from 'react';
import ReactDOMClient from 'react-dom/client';
import singleSpaReact from 'single-spa-react';
import { logger } from '@ecosystem/newron-client-lib';
import { feedbackV2 } from '@ecosystem/newron-design-system';
import { Root } from './root/Root';

import './styles.css';
import axios from 'axios';
import { recordAxiosError } from './tools/axios.trace';

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    try {
      recordAxiosError(error);
    } catch (e) {
      logger.info('axios intercept recordAxiosError failed', e);
    }
    return Promise.reject(error);
  }
);

const lifecycles = singleSpaReact({
  renderType: 'createRoot',
  React,
  ReactDOMClient,
  rootComponent: Root,
  errorBoundary(err: Error, info: React.ErrorInfo) {
    logger.error(err, {
      componentStack: info.componentStack,
    });
    return (
      <div className="mx-32 my-16">
        <feedbackV2.Alert
          title={
            <>
              The requested data for this page has failed to load.
              <br /> Please refresh your browser to try again. If this issue persists, please contact your GfK
              representative.
            </>
          }
          type="error"
        />
      </div>
    );
  },
});

export const { bootstrap, mount, unmount } = lifecycles;

export * from './index';
